export enum Roles {
    'SYTEM_ADMIN' = 1,
    'DOCUMENT_MANAGER' = 2,
    'SOMATUS_USER' = 3,
    'PRACTICE_USER' = 4
}